import {BIBLIOGRAPHIC_PRIORITY_SUBTASKS, CUSTOM_FORMS_PRIORITY_SUBTASKS} from "app/utils/constants/intentPriorities";

export const sortIntentsByCategory = (category, intents) => {
  if (!Array.isArray(intents)) return intents;

  const sorted = [...intents];

  if (category === "Bibliographic Data Extraction") {
    sorted.sort((a, b) => {
      const aIndex = BIBLIOGRAPHIC_PRIORITY_SUBTASKS.indexOf(a.subtask_name);
      const bIndex = BIBLIOGRAPHIC_PRIORITY_SUBTASKS.indexOf(b.subtask_name);

      const aIsPriority = aIndex !== -1;
      const bIsPriority = bIndex !== -1;

      if (aIsPriority && bIsPriority) {
        return aIndex - bIndex;
      }

      if (aIsPriority) return -1;
      if (bIsPriority) return 1;

      return a.subtask_name.localeCompare(b.subtask_name);
    });
  } else if (category === "Custom Forms") {
    sorted.sort((a, b) => {
      const aIndex = CUSTOM_FORMS_PRIORITY_SUBTASKS.indexOf(a.subtask_name);
      const bIndex = CUSTOM_FORMS_PRIORITY_SUBTASKS.indexOf(b.subtask_name);

      const aIsPriority = aIndex !== -1;
      const bIsPriority = bIndex !== -1;

      if (aIsPriority && bIsPriority) {
        return aIndex - bIndex;
      }

      if (aIsPriority) return -1;
      if (bIsPriority) return 1;

      return a.subtask_name.localeCompare(b.subtask_name);
    });
  } else {
    sorted.sort((a, b) => a.subtask_name.localeCompare(b.subtask_name));
  }

  return sorted;
};

export const getAllIpAppIds = (app) => {
  if (!app || !app.ipApps) return [];

  const allItems = Object.values(app.ipApps).flat();
  const ids = allItems
    .map(item => item?.ip_app_id)
    .filter(id => id != null);

  return [...new Set(ids)];
};

export const addIpAppIds = (selectedIpApps = [], ipAppIds = []) =>
  [...new Set([...selectedIpApps, ...ipAppIds])];

export const removeIpAppIds = (selectedIpApps = [], ipAppIds = []) =>
  selectedIpApps.filter(id => !ipAppIds.includes(id));

export const toggleIpAppIds = (selectedIpApps = [], ipAppIds = [], isCurrentlyChecked) =>
  isCurrentlyChecked
    ? removeIpAppIds(selectedIpApps, ipAppIds)
    : addIpAppIds(selectedIpApps, ipAppIds);

export const getAppIntentSelectionState = (app, selectedIpApps = []) => {
  const appIpAppIds = getAllIpAppIds(app);
  const selectedCount = appIpAppIds.filter(id => selectedIpApps.includes(id)).length;
  const areAllAppIntentsChecked = appIpAppIds.length > 0 && selectedCount === appIpAppIds.length;
  const areSomeAppIntentsChecked = selectedCount > 0 && !areAllAppIntentsChecked;

  return { appIpAppIds, areAllAppIntentsChecked, areSomeAppIntentsChecked };
};
